// extracted by mini-css-extract-plugin
export var excerpt = "usecase-preview-module--excerpt--19283 typography-module--paragraphSans--0fb30";
export var item = "usecase-preview-module--item--6f25c";
export var root = "usecase-preview-module--root--38e61";
export var title = "usecase-preview-module--title--81819";
export var titleItem = "usecase-preview-module--titleItem--15ad1";